/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Tenant = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
        this.tenantID = 0;

	},

	getTenant: function(context, callback) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "tenants/" + self.tenantID;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			if (response.data[0]) {
				context.setState({
					tenantData: response.data[0].data,
					active: response.data[0].active,
					attachments: response.data[0].attachments,
					contract_data_id: response.data[0].contract_data ? response.data[0].contract_data.contract_data_id : 0,
					space_id: response.data[0].space_id,
					screening: response.data[0].screening,
					screening_attachments: response.data[0].screening_attachments
				});
			}
			if (callback) {
				callback(response);
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},

	/**
	*
	* Deletes a tenant
	*
	*/
	deleteTenant: function(e){
		// #  Localize this instance for use on success
      var self = this;
      // #  Send out success message
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this tenant.  All data associated will be deleted and you will not be able to recover.","Yes, Delete");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "tenants/" + self.tenantID;
		// #  Send to server object for processing
		var data = self.server.getData(url,null,false, "DELETE");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again.", "danger", "top", "center");
          }
          else
          {
            // # .Hard reset backdrop
			modal.resetBackDrop();
            // #  Send out success message
            modal.showSuccess("Tenant Deleted!","This tenant has been dropped.  All associated information with this tenant has been removed.");
            // #  Bind okay button
            jQuery(".move-on").on('click',function() {
				browserHistory.goBack();
            });
          }
        })
        .fail(function(e){
			console.log(e);
        });
      });
	},

	/**
	*
	* Saves tenant data
	*
	*/
	saveTenant: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "tenants/" + self.tenantID;
		var params = context.state.tenantData;
		params['contract_data_id'] = context.state.contract_data_id;
		params['space_id'] = context.state.space_id;
		params['email_tenant'] = context.state.emailTenant;
		params['company'] = context.state.tenantData.company;
		// #  Send to server object for processing
		var data = this.server.getData(url,params, true, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				var tenant_id = 0;
				var type = "";
				if(self.tenantID == 0) {
					tenant_id = response.data.tenant_id;
					type = "new_tenant";

					context.triggerUpload(tenant_id, type);
				} else {
					modal.showSuccess("Tenant Updated!","This tenant has been successfully updated.");
				}
			}
		})
		.fail(function(e){
			if (e.status == 404) {
				modal.showInfo(e.responseText, "danger", "top", "center");
			} else {
				modal.showInfo("Oops! Something went wrong while saving the tenant data!", "danger", "top", "center");
			}
		});
	},

	/**
	*
	* set default state for when creating a new user
	*
	*/
	setDefaultState: function(context){
		context.setState({ tenantData: {}});
	},

    setTenantID: function(tenantID){
        this.tenantID = tenantID;
	},

	createPaymentPlan: function(paymentPlan, callback) {
		var self = this;
      	modal.showDangerModalWithOK("Are you sure?","You are about to create a payment plan for a total of $" + paymentPlan.rentAmount + " over the next " + paymentPlan.termLength + " months.","Start!");
      	jQuery(".move-on").on('click',function() {
			var url = "tenants/" + paymentPlan.tenant_id + "/paymentplan";
			var params = paymentPlan;
			var data = self.server.getData(url,params,false, "POST");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					callback(response)
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Something went wrong while creating the payment plan!", "danger", "top", "center");
			});
		});
	},
	updatePaymentPlan: function(paymentPlan, tenantID, callback) {
		var self = this
		var url = "tenants/" + tenantID + "/paymentplan/" + paymentPlan.payment_plan_id;
		var params = paymentPlan;
		var data = self.server.getData(url,params,false, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while updating the payment plan!", "danger", "top", "center");
		});
	},
	deletePaymentPlan: function(paymentPlan, tenantID, callback) {
		var self = this
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this payment plan.","Delete!");
		jQuery(".move-on").on('click',function() {
			var url = "tenants/" + tenantID + "/paymentplan/" + paymentPlan.payment_plan_id;
			var params = paymentPlan;
			var data = self.server.getData(url,params,false, "DELETE");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					callback(response)
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Something went wrong while deleting the payment plan!", "danger", "top", "center");
			});
		});
	},
	sendActivation: function(id, callback) {
		var self = this;
		var url = "tenant/invitation/" + id;
		var data = self.server.getData(url, null, true, "POST");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseJSON.messages, "danger", "top", "center");
		});
	},
	getSignatureEmail: function(callback) {
		var self = this;
		var url = "tenant/electronic/request";
		var data = self.server.getData(url, null, true, "GET");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e.responseJSON.messages, "danger", "top", "center");
		});
	},
	switchRentStatus: function(tenantID, callback) {
		var url = "tenant/status/" + tenantID;
		var data = this.server.getData(url, null, true, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while switching the tenant status!", "danger", "top", "center");
		});
	},
	toggleManualPayment: function(tenantID, callback) {
		var url = "tenant/manual/payment/status/" + tenantID;
		var data = this.server.getData(url, null, true, "PUT");
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				callback(response)
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Something went wrong while switching the tenant status!", "danger", "top", "center");
		});
	},
	sendPayout: function(payout, callback) {
		var self = this;
      	modal.showDangerModalWithOK("Are you sure?","You are about to send a payment for a total of $" + payout.payout +".", "Continue");
      	jQuery(".move-on").on('click',function() {
			var url = "tenant/payout/" + payout.tenant_id;
			var params = payout;
			var data = self.server.getData(url,params,false, "POST");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					callback(response)
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Something went wrong while creating the payout!", "danger", "top", "center");
			});
		});
	},
});

export let tenant = new Tenant();


// WEBPACK FOOTER //
// app/core/controllers/Tenant.js